export default __webpack_public_path__ + "static/bridge-xs-9f833c72ea1228512c9ab64e1e2277bb.png";